import React from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';
export function TransformationQuote() {
  return <section className="py-40 px-6 bg-charcoal relative border-t border-gold/10 overflow-hidden" data-id="element-223">
      {/* Background ambient light */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[400px] bg-gold-muted rounded-full blur-[150px] opacity-20 pointer-events-none" data-id="element-224" />

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-225">
        <motion.div initial={{
        opacity: 0,
        scale: 0.8
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="mb-12 flex justify-center" data-id="element-226">
          <Quote className="w-16 h-16 text-gold/30 rotate-180" strokeWidth={1} data-id="element-227" />
        </motion.div>

        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.2,
        ease: 'easeOut'
      }} className="font-playfair text-4xl md:text-5xl lg:text-6xl text-white leading-tight mb-12" data-id="element-228">
          "En 3 días no lo habrás olvidado, pero habrás dejado de{' '}
          <span className="text-gold italic" data-id="element-229">necesitarlo</span>. Bienvenido de
          vuelta al trono."
        </motion.h2>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="w-24 h-[1px] bg-gold mx-auto opacity-50" data-id="element-230" />
      </div>
    </section>;
}